import React, { Component, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Navbar, NavItem, Button, NavbarToggler, Spinner } from "reactstrap";
import Hls from "hls.js";
import { hideAndShowLeftSideBar } from "services/dataServices/fullScreenService";
import { getUserProfileData } from "services/dataServices/userProfileService";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { getEncodedJWTToken } from "services/utility";
import config from "pwaConfig";

class Exam extends Component {
  constructor(props) {
    super(props);
    const {type} = this.props.match.params;
    const {firstname} = this.props.match.params;
    const {lastname} = this.props.match.params;
    const {email} = this.props.match.params;
    const {schoolName} = this.props.match.params;
    console.log(`Inside Exam :: ${schoolName}`);
    // let testId = 1
    // if(examType && (examType).toUpperCase()==="JEE"){
    //   testId = 4
    // }else if(examType && (examType).toUpperCase()==="NEET"){
    //   testId = 5
    // }else if(examType && (examType)==="12passout"){
    //   testId = 9
    // }else if(examType && (examType)==="12"){
    //   testId = 10
    // }else if(examType && (examType)==="11"){
    //   testId = 11
    // }else 
    
    // if(type && (type)==="6"){
    //   testId = 12
    // }else if(type && (type)==="7"){
    //   testId = 13
    // }else if(type && (type)==="8"){
    //   testId = 14
    // }else if(type && (type)==="9"){
    //   testId = 15
    // }else if(type && (type)==="11"){
    //   testId = 16
    // }else if(type && (type)==="12"){
    //   testId = 16
    // }else if(type && (type)==="13"){
    //   testId = 16
    // }
    
    
    this.state = {
      video: null,
      userProfie: getUserProfileData(),
      url : `https://pace.ilearn.edusquares.com/?testId=${type}&token=`,
      firstName: firstname,
      lastName : lastname,
      email : email,
      schoolName : schoolName,
      type : type
    };
  }
  

  componentDidMount(props) {
    hideAndShowLeftSideBar(true);
    if (
        this.props.loggedInUser.school.schoolChainId !==
        this.props.loggedInUser.school.schoolChainId
        ) {
          alert('This section is not currently accessible')
          this.props.history.push(`/concepts`)
        }
    // console.log(this.state.userProfie);
    
  }

  componentWillUnmount() {
    hideAndShowLeftSideBar(false);
  }

  createPayload=()=>{
      let userdata = this.props.loggedInUser;
    //   console.log(userdata);
    let UnixEpoch = moment().unix()
      let payload = 
    
      {
        //id: userdata.id,
        user_mobile: userdata.user_mobile,
        username: userdata.id,
        //country_code: '91',
        //authenticated: this.props.isLoggedIn,
        //school_id: userdata.school_id,
        board_name: userdata.board_name,
        //lang_pref: userdata.lang_pref,
        grade_name: userdata.grade_name,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        user_email: this.state.email,
        schoolName: this.state.schoolName,
        migratedId: userdata.migratedId ? userdata.migratedId : userdata.id,
        //exp: UnixEpoch,
        };

        
        // let token = getEncodedJWTToken(inputData);
        console.log(payload);
        let jwt = require("jsonwebtoken");
        let token = jwt.sign(payload, config.spayeeToken);
        console.log(`Token :: ${token}`);
        return token;
  }

 getUrl = () => {
   let url = `${this.state.url}${this.createPayload()}`;
   window.location.href = url;
  // alert(url);
  // console.log(url)
  };
  
  hideSpinner = () => {
    // console.log("here");
    document.getElementById("loader").style.display = "none";
  };

  render() {
    this.getUrl();
    return (
      <Fragment>
       

       {/* <div className="page-back">
          <button
            type="button"
            className="action-quiz top"
            onClick={() => this.props.history.push("/concepts")}
          >
            <icon className="icon-back-arrow top" />
          </button>
        </div> */}
        <div className="embed-responsive">
        <div id="loader">
          <Spinner id="spnr" size="xxl" color="primary" />
        </div>
           {/*  <iframe
              src={this.getUrl()}
              width="100%"
              height="100%"
              onLoad={this.hideSpinner}
            ></iframe>
 */}          
        </div>
      </Fragment>
    );
  }
}



const mapStateToProps = ({ user, auth }) => ({
  loggedInUser: user,
  isLoggedIn: auth?.isAuthenticated,
});

export default connect(
    mapStateToProps,
  )(withRouter(Exam));
  

